import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { findRoute } from './site';
import { applyHeadToDocument, buildHead } from './head';
import { trackPageView } from './analytics';

// Keeps <head> metadata in sync with the current route after client-side navigation.
// The initial values are already in the prerendered HTML (scripts/prerender.mjs).
const SeoManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const head = buildHead(findRoute(pathname));
    applyHeadToDocument(head);
    trackPageView(pathname, head.title);
  }, [pathname]);

  return null;
};

export default SeoManager;
